<script setup lang="ts">
    interface Props {
        name?: string;
        url?: string;
        lang?: string;
        type?: 'pdf' | 'jpeg' | 'png' | 'doc' | 'oth';
        /** Saves the file under this name instead of opening it in a new tab. */
        download?: string;
    }

    const props = defineProps<Props>();
</script>
<template>
    <div class="link-wrapper">
        <a
            :target="download ? undefined : '_blank'"
            :href="url"
            :download="download"
        >
            <img
                v-if="props.type == 'jpeg' || props.type == 'png'"
                src="~/assets/icons/file-image.svg"
                alt=""
            />
            <img
                v-if="props.type == 'pdf' || props.type == 'doc'"
                src="~/assets/icons/file-text.svg"
                alt=""
            />
            <img
                v-if="props.type == 'oth'"
                src="~/assets/icons/download.svg"
                alt=""
            />
            <p class="link-name">{{ props.name }}</p>

            <span
                v-if="props.lang"
                class="lang"
            >
                ({{ props.lang }})</span
            >
        </a>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/download.scss';
</style>
